import React, { Component, Fragment } from 'react'
import { Col, DatePicker, Form, Input, Row, Select, Spin } from 'antd'
import Dropdowns from '../../../../../api/Dropdowns'
import { dateVal, strVal } from '../../../../../modules/Utils'
import Corporate from '../../../../../api/Corporate'
import { get, isEmpty } from 'lodash'
import Employees from '../../../../../api/Employees'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'
import BankingModal from '../../Modal/Banking'
import IconText from '../../../../../elements/IconText'

const FormItem = Form.Item
const { TextArea } = Input
const { Option } = Select

class Overview extends Component {
  constructor (props) {
    super(props)
    this.corporateApi = new Corporate()
    this.dropdownApi = new Dropdowns()
    this.key = props.employee._key

    this.api = new Employees()
    this.state = {
      statusList: [],
      orgList: [],
      bankList: [],
      contractList: [],
      updating: false,
      contract: {},
      fetchingBank: false,
      fetchingContracts: false,
    }
  }

  handleContractChange = value => {
    if (this.props.type !== 'view') {
      const contract = this.state.contractList.find(c => c._id === value)
      this.props.updatePayQuery('contract', contract)
      this.setState({
        contract,
      })
    }
  }
  handleBankChange = value => {
    const bank = this.state.bankList.find(c => c._id === value)
    this.props.updatePayQuery('bank', bank)
    this.setState({
      bank,
    })
  }

  async componentDidMount () {
    await this.fetchBanks()
    await this.fetchContracts()
    if (!isEmpty(this.props.payQuery)) {
      this.handleContractChange(get(this.props.payQuery, 'contract._id'))
      this.handleBankChange(get(this.props.payQuery, 'bank._id'))
    }
  }

  fetchBanks = async () => {
    this.setState({ fetchingBank: true })
    let bankList = await this.api.banks.list(this.key)
    this.setState({
      bankList: bankList.filter(b => b.status === 'Active'),
      fetchingBank: false,
    })
  }
  fetchContracts = async () => {
    this.setState({ fetchingContracts: true })
    let contractList = await this.api.contracts.list(this.key)

    this.setState({
      contractList: contractList.filter(c => c.status === 'Approved'),
      fetchingContracts: false,
    })
  }

  render () {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { payQuery, employee, member } = this.props
    return (
      <Fragment>
        <BankingModal
          employee={employee}
          bank={this.state.bank}
          member={member}
          type={'view'}
          visible={this.state.showBank}
          handleCancel={() =>
            this.setState({
              showBank: false,
            })
          }
        />
        <Form layout="horizontal">
          <Row>
            <Col span={12}>
              <FormItem label="Title" {...formItemLayout} hasFeedback>
                {getFieldDecorator('title', {
                  initialValue: strVal(payQuery, 'title'),
                })(<Input placeholder="Title"/>)}
              </FormItem>
            </Col>
            <Col span={12}>
              <Spin spinning={this.state.fetchingContracts}>
                <FormItem label="Contract" {...formItemLayout}>
                  {getFieldDecorator('contract._id', {
                    initialValue: get(payQuery, 'contract._id'),
                    rules: [
                      {
                        required: true,
                        message: 'Contract can\'t be empty ',
                      },
                    ],
                  })(
                    <Select
                      style={get(payQuery, 'contract._id') && { width: '85%' }}
                      onChange={this.handleContractChange}
                      placeholder="Contract">
                      {this.state.contractList.map(b => (
                        <Option value={b._id}>{b.code}</Option>
                      ))}
                    </Select>,
                  )}
                  {get(payQuery, 'contract._id') && (
                    <a
                      href={`#/people/member/${get(member, '_key')}/contracts/${get(
                        payQuery,
                        'contract._key',
                      )}/view`}
                      target={'_blank'}>
                      <IconText text={'Open'} type="arrows-alt"/>
                    </a>
                  )}
                </FormItem>
              </Spin>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Company" {...formItemLayout}>
                {getFieldDecorator('company.fn', {
                  initialValue: get(payQuery, 'company.fn') || get(payQuery, 'contract.company.fn'),
                })(<Input placeholder={'Title'} disabled/>)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Currency" {...formItemLayout}>
                <Input value={strVal(payQuery, 'contract.pay.currency')} disabled/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Spin spinning={this.state.fetchingBank}>
                <FormItem label="Bank Account" {...formItemLayout}>
                  {getFieldDecorator('bank._id', {
                    initialValue: get(payQuery, 'bank._id'),
                    rules: [
                      {
                        required: true,
                        message: 'Bank Account Selection can\'t be empty ',
                      },
                    ],
                  })(
                    <Select
                      style={get(payQuery, 'bank._id') && { width: '85%' }}
                      onChange={this.handleBankChange}
                      placeholder="Bank Selection">
                      {this.state.bankList.map(b => (
                        <Option value={b._id}>{b.nickname}</Option>
                      ))}
                    </Select>,
                  )}
                  {get(payQuery, 'bank._id') && (
                    <a
                      onClick={() =>
                        this.setState({
                          showBank: true,
                        })
                      }>
                      <IconText text={'Show'} type="arrows-alt"/>
                    </a>
                  )}
                </FormItem>
              </Spin>
            </Col>
            <Col span={12}>
              <FormItem label="Bank Account Number" {...formItemLayout}>
                <Input value={strVal(this.state, 'bank.number')} disabled/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Start Date" {...formItemLayout}>
                {getFieldDecorator('date.start', {
                  initialValue: dateVal(payQuery, 'date.start'),
                  rules: [
                    {
                      required: true,
                      message: 'Start Date can\'t be empty ',
                    },
                  ],
                })(<DatePicker style={{ width: '100%' }} placeholder="Start Date"/>)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="End Date" {...formItemLayout}>
                {getFieldDecorator('date.expiry', {
                  initialValue: dateVal(payQuery, 'date.expiry'),
                })(<DatePicker style={{ width: '100%' }} placeholder="End Date"/>)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Description" {...formItemLayout} hasFeedback>
                {getFieldDecorator('description', {
                  initialValue: strVal(payQuery, 'description'),
                })(<TextArea placeholder="Description" rows={4}/>)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Fragment>
    )
  }
}

export default compose(Form.create(), withLoadingSection)(Overview)
